import {Component, Input, OnInit} from '@angular/core';
import {MediaService} from '../../services/media.service';
import {DateMomentService} from '../../services/date-moment.service';
import {TranslationService} from '../../services/translation.service';
import {environment} from '../../../environments/environment';
import {LocaleService} from '../../services/locale.service';
import {AcademyMedia} from '../../models/academy-media.model';
import {Router} from '@angular/router';
import {User} from '../../models/user.model';

@Component({
  selector: 'app-lecture-playlist',
  templateUrl: './lecture-playlist.component.html',
  styleUrls: ['./lecture-playlist.component.scss'],
    providers: [MediaService]
})
export class LecturePlaylistComponent implements OnInit {

    @Input() lecture: AcademyMedia;
    environment: any = environment;
    @Input() user: User;
    @Input() card: boolean;
    @Input() thumbFormat: string;
    @Input() favoriteElement: boolean = true;
    @Input() isForReport: boolean = false;
    locale: string;

    constructor(public translationService: TranslationService,
                private mediaService: MediaService,
                public dateMomentService: DateMomentService,
                private router: Router,
                private localeService: LocaleService) {
    }

    ngOnInit() {
        this.locale = this.localeService.currentLocale();
    }

    goToUserProfile(url) {
        this.router.navigateByUrl(url);
    }

    goToVideo() {
        this.mediaService.goToVideo(this.lecture);
    }

    addMediaToFavorite() {
        this.mediaService.addMediaToFavorite(this.lecture.getId()).subscribe(
            () => {
                const favorite = this.lecture.getFavorite(this.user);
                if (favorite === true) {
                    this.lecture.getMedia().favorite = false;
                    this.user.removeFavoriteAcademyMedia(this.lecture.getId());
                } else {
                    this.lecture.getMedia().favorite = true;
                    if (typeof this.user.addFavoriteAcademyMedia === 'function') {
                        this.user.addFavoriteAcademyMedia(this.lecture.getId());
                    }
                }
            },
            err => {}
        );
    }

}
